export function AnalyticsStatsCard({ label, value, change }) {
  return (
    <div className="flex flex-col gap-2 flex-1">
      <p className="text-sm font-medium text-muted-foreground flex justify-between">
        {label}
        {change > 0 && <span>{change}%</span>}
      </p>
      <p className="text-xl md:text-3xl font-semibold">{value ?? "-"}</p>
    </div>
  );
}
